<template>
    <div>
        <b-container>
            <b-row>
                <b-col>
                    <div  style="text-align:center">
                        <img  v-if="getContainerOptionsToAdd.barrel1" width="40px" src="../assets/barrel.png"/>

                        <b-form-group v-if="getContainerOptionsToAdd.barrel1" label="Barrel">
                            <b-form-group
                                label-cols-sm="3" 
                                label-size="sm"
                                label="Size"
                                label-align-sm="right"
                                label-for="nested-barrelsize1"
                            >                                          
                                <b-form-select id='nested-barrelsize1' v-model="barrel1Size" :options="barrelSizeOptions">
                                    <template v-slot:first>
                                        <!-- This is required to prevent bugs with Safari -->
                                        <option disabled value="">Choose barrel1 size</option>
                                    </template>
                                </b-form-select>
                            </b-form-group>
                                        
                            <b-form-group
                                label-cols-sm="3"
                                label-size="sm"
                                label="Cost($)"
                                label-align-sm="right"
                                label-for="nested-barrel1cost"
                            >
                                <b-form-input  size="sm" v-model="barrel1Cost" id="nested-barrel1cost"></b-form-input>
                            </b-form-group>
                            <b-form-group
                                label-cols-sm="3"
                                label-size="sm"
                                label="Quantity"
                                label-align-sm="right"
                                label-for="nested-barrel1quantity"
                            >
                                <b-form-input  size="sm" v-model="barrel1Quantity" id="nested-barrel1quantity"></b-form-input>
                            </b-form-group>

                        </b-form-group>

                        <b-form-group  v-if="getContainerOptionsToAdd.barrel2"  label="Barrel 2">
                            <b-form-group
                                label-cols-sm="3" 
                                label-size="sm"
                                label="Size"
                                label-align-sm="right"
                                label-for="nested-barrelsize2"
                            >                                          
                                <b-form-select id='nested-barrelsize2' v-model="barrel2Size" :options="barrelSizeOptions">
                                    <template v-slot:first>
                                        <!-- This is required to prevent bugs with Safari -->
                                        <option disabled value="">Choose barrel2 size</option>
                                    </template>
                                </b-form-select>
                            </b-form-group>
                                        
                            <b-form-group
                                label-cols-sm="3"
                                label-size="sm"
                                label="Cost($)"
                                label-align-sm="right"
                                label-for="nested-barrel2cost"
                            >
                                <b-form-input  size="sm" v-model="barrel2Cost" id="nested-barrel2cost"></b-form-input>
                            </b-form-group>
                            <b-form-group
                                label-cols-sm="3"
                                label-size="sm"
                                label="Quantity"
                                label-align-sm="right"
                                label-for="nested-barrel2quantity"
                            >
                                <b-form-input  size="sm" v-model="barrel2Quantity" id="nested-barrel2quantity"></b-form-input>
                            </b-form-group>

                        </b-form-group>


                    </div>
                </b-col>
                <b-col>
                    <div  style="text-align:center">
                        <img  v-if="getContainerOptionsToAdd.can" width="40px" src="../assets/can2.png"/>
                        <b-form-group  v-if="getContainerOptionsToAdd.can"  label="Cans">
                            <b-form-group
                                label-cols-sm="3" 
                                label-size="sm"
                                label="Oz/Can:"
                                label-align-sm="right"
                                label-for="nested-street"
                            >
                                
                                <b-form-input  size="sm" v-model="ozPerCan"  type="number" id="nested-street"></b-form-input>
                            </b-form-group>
                                        
                            <b-form-group
                                label-cols-sm="3"
                                label-size="sm"
                                label="Case Size"
                                label-align-sm="right"
                                label-for="nested-street"
                            >
                                <b-form-input  size="sm" v-model="cansPerCase" id="nested-street"></b-form-input>
                            </b-form-group>
                            <b-form-group
                                label-cols-sm="3"
                                label-size="sm"
                                label="Cost($)"
                                label-align-sm="right"
                                label-for="nested-cancost"
                            >
                                <b-form-input  size="sm" v-model="canCost" id="nested-cancost"></b-form-input>
                            </b-form-group>

                            <b-form-group
                                label-cols-sm="3"
                                label-size="sm"
                                label="Quantity"
                                label-align-sm="right"
                                label-for="nested-canquantity"
                            >
                                <b-form-input  size="sm" v-model="canQuantity" id="nested-canquantity"></b-form-input>
                            </b-form-group>


                        </b-form-group>
                    </div>
                </b-col>
                <b-col>
                    <div  style="text-align:center">
                        <img  v-if="getContainerOptionsToAdd.bottle" width="40px" src="../assets/bottle.png"/>
                        <b-form-group  v-if="getContainerOptionsToAdd.bottle" label="Bottles">
                            <b-form-group
                                label-cols-sm="3" 
                                label-size="sm"
                                label="Oz/Bottle:"
                                label-align-sm="right"
                                label-for="nested-street"
                            >
                                
                                <b-form-input  size="sm" v-model="ozPerBottle"  type="number" id="nested-street"></b-form-input>
                            </b-form-group>
                                        
                            <b-form-group
                                label-cols-sm="3"
                                label-size="sm"
                                label="Case Size"
                                label-align-sm="right"
                                label-for="nested-street"
                            >
                                <b-form-input  size="sm"  v-model="bottlesPerCase" type='number' id="nested-street"></b-form-input>
                            </b-form-group>
                            <b-form-group
                                label-cols-sm="3"
                                label-size="sm"
                                label="Cost($)"
                                label-align-sm="right"
                                label-for="nested-bottlecost"
                            >
                                <b-form-input  size="sm" v-model="bottleCost" id="nested-bottlecost"></b-form-input>
                            </b-form-group>

                            <b-form-group
                                label-cols-sm="3"
                                label-size="sm"
                                label="Quantity"
                                label-align-sm="right"
                                label-for="nested-bottlequantity"
                            >
                                <b-form-input  size="sm" v-model="bottleQuantity" id="nested-bottlequantity"></b-form-input>
                            </b-form-group>


                        </b-form-group>
                    </div>
                </b-col>
            </b-row>
            <!-- End Of New Size Inputs -->
            <b-row>
                <b-col>
                    <div style="margin-top:20px; margin-bottom:20px">
                        <div v-if="showAddBeerError" class='inputwarning'> Please correct the errors above</div>
                        <b-button  size="lg" @click="addBeerSize()" class="btn btn-success">Add Containers</b-button>
                    </div>
                </b-col>

            </b-row>


        </b-container>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import { currentUser } from '../firebaseConfig'
    const fb = require('../firebaseConfig.js')

    export default {
        props: ['beer'],
        computed: {
            ...mapState(['userProfile', 'currentUser','userInventory', 'promotionsEnabled', 'distributorBreweries']),
            
            getContainerOptionsToAdd(){
                var theOptions = {}
                if (this.beer.barrel1Size||this.beer.container=='Barrel') theOptions.barrel1 = 0
                else theOptions.barrel1 = 1
                if (this.beer.barrel2Size) theOptions.barrel2 = 0
                else theOptions.barrel2 = 1
                if (this.beer.ozPerCan||this.beer.container=='cans') theOptions.can = 0
                else theOptions.can = 1
                if (this.beer.ozPerBottle||this.beer.container =='bottles') theOptions.bottle = 0
                else theOptions.bottle = 1
                return theOptions

            },
        },
        data() {
            return {
                updatingItem:false,
                otherDeliveryMethod:'', 
                invalidSize : false,
                showAddBeerError: false,
                barrelSizeOptions: [
                    { value: '1/2 Barrel, 15.5 Gal', text: '1/2 Barrel, 15.5 Gal'},
                    { value: '13.2 Gal, 50L', text: '13.2 Gal, 50L'},
                    { value: '1/4th Barrel, 7.75 Gal', text: '1/4th Barrel, 7.75 Gal'},
                    { value: '1/6th Barrel 5.16 Gal', text: '1/6th Barrel, 5.16 Gal'},
                    ],
                    barrel1Size:'',
                    barrel1Quantity:'',
                    barrel1Cost:'',
                    barrel2Size:'',
                    barrel2Quantity:'',
                    barrel2Cost:'',
                    cansPerCase:'',
                    canQuantity:'',
                    ozPerCan:'',
                    canCost:'',
                    ozPerBottle:'',
                    bottlesPerCase:'',
                    bottleQuantity:'',                  
                    bottleCost:'',

            }
        },
        

        methods:{
            addBeerSize(){
                console.log("Adding container")
                var updateDictionary = {}
                var deliveryMethod=''

                //Check if this beer was not multisize before. If it wasn't, move the current container to the appropriate container
                if(this.beer.multiSize != 1){
                    //Beer was not multisize. Check current container, and move to multisize container
                    updateDictionary.multiSize = 1
                    if(this.beer.container =='Barrel'){
                        updateDictionary.barrel1Size = this.beer.size
                        updateDictionary.barrel1Cost = this.beer.cost
                        updateDictionary.barrel1Quantity = this.beer.quantity

                    }
                    if(this.beer.container =='cans'){
                        updateDictionary.ozPerCan = this.beer.size
                        updateDictionary.cansPerCase = this.beer.perCase
                        updateDictionary.canCost = this.beer.cost
                        updateDictionary.canQuantity = this.beer.quantity

                    }
                    if(this.beer.container =='bottles'){
                        updateDictionary.ozPerBottle = this.beer.size
                        updateDictionary.bottlesPerCase = this.beer.perCase
                        updateDictionary.bottleCost = this.beer.cost
                        updateDictionary.bottleQuantity = this.beer.quantity

                    }
                }
                //Check what containers have been added
                var hasBarrels1 = 0
                var hasBarrels2 = 0
                var hasCans = 0
                var hasBottles = 0
                //CHECK IF ALL FIELDS HAVE BEEN ENTERED FOR A CONTAINER
                if (this.barrel1Size||this.barrel1Cost||this.barrel1Quantity){
                    if(!this.barrel1Size||!this.barrel1Cost||!this.barrel1Quantity) this.invalidSize = true
                    else {
                        hasBarrels1 = 1
                        updateDictionary.barrel1Size = this.barrel1Size
                        updateDictionary.barrel1Cost = this.barrel1Cost
                        updateDictionary.barrel1Quantity = this.barrel1Quantity
                    }
                } 
                if (this.barrel2Size||this.barrel2Cost||this.barrel2Quantity){
                    if(!this.barrel2Size||!this.barrel2Cost||!this.barrel2Quantity) this.invalidSize = true
                    else{
                        hasBarrels2 = 1                        
                        updateDictionary.barrel2Size = this.barrel2Size
                        updateDictionary.barrel2Cost = this.barrel2Cost
                        updateDictionary.barrel2Quantity = this.barrel2Quantity
                    }                   
                } 
                if (this.ozPerCan||this.canCost||this.cansPerCase||this.canQuantity){
                    if (!this.ozPerCan||!this.canCost||!this.cansPerCase||!this.canQuantity) this.invalidSize = true
                    else{
                        hasCans = 1
                        updateDictionary.ozPerCan = this.ozPerCan
                        updateDictionary.canCost = this.canCost
                        updateDictionary.cansPerCase = this.cansPerCase
                        updateDictionary.canQuantity = this.canQuantity
                    }                   
                } 
                if(this.ozPerBottle||this.bottleCost||this.bottlesPerCase||this.bottleQuantity){
                    if(!this.ozPerBottle||!this.bottleCost||!this.bottlesPerCase||!this.bottleQuantity) this.invalidSize = true
                    else{
                        hasBottles = 1
                        updateDictionary.ozPerBottle = this.ozPerBottle
                        updateDictionary.bottleCost = this.bottleCost
                        updateDictionary.bottlesPerCase = this.bottlesPerCase
                        updateDictionary.bottleQuantity = this.bottleQuantity
                    }    
                }

                if(this.invalidSize){
                    
                    this.showAddBeerError = true
                    this.$bvToast.toast('Please check all fields are entered correctly', {
                        title: 'Error!',
                        solid:true,
                        variant: 'danger',
                        autoHideDelay: 5000,
                        appendToast: false
                        })
                        this.$bvModal.show("modal-quantityexceeds")

                    return
                } 

                else this.showAddBeerError = false  

                console.log("Update dictionary = ")
                console.log(updateDictionary)
                console.log("id = " + this.beer.id)

                this.updatingItem = true
                var fbref = ''
                fbref=fb.beersCollection

                fbref.where('id', '==', this.beer.id).where('uid', '==', this.currentUser.uid).get().then(docs => {
                    docs.forEach(doc => {
                        fbref.doc(doc.id).update(updateDictionary)
                        this.updatingItem = false
                        this.$bvToast.toast(name + ' Updated', {
                        title: 'Inventory Update',
                        solid:true,
                        variant: 'success',
                        autoHideDelay: 3000,
                        appendToast: false
                        })

                    })
                    }).catch(err => {
                    console.log(err)
                    })

                //End of new sizes

            },

        }
        
    }
</script>